import { getStore } from "./db";

class IndexedDBStorage {
  async set(key, value) {
    const store = await getStore("readwrite");

    return new Promise((resolve, reject) => {
      const request = store.put({ key, value });

      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  }

  async get(key) {
    const store = await getStore();

    return new Promise((resolve, reject) => {
      const request = store.get(key);

      request.onsuccess = () => {
        resolve(request.result?.value ?? null);
      };

      request.onerror = () => reject(request.error);
    });
  }

  async remove(key) {
    const store = await getStore("readwrite");

    return new Promise((resolve, reject) => {
      const request = store.delete(key);

      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  }

  async clear() {
    const store = await getStore("readwrite");

    return new Promise((resolve, reject) => {
      const request = store.clear();

      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  }

  async has(key) {
    const value = await this.get(key);
    return value !== null;
  }
}

export const indexedDBStorage = new IndexedDBStorage();